import { render, staticRenderFns } from "./EmailAddressExportPage.vue?vue&type=template&id=528d20ae&"
import script from "./EmailAddressExportPage.vue?vue&type=script&lang=js&"
export * from "./EmailAddressExportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports